import React, { useRef } from 'react'
import { Services } from '@/services/services';
import { CurrentSession, SessionService } from '@/services/repository/session';
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout';
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable';
import { formatDate } from '@/common/time';
import { isDesktopScreen, useResponsiveChange } from '@/common/device';
import { useNavigate } from 'react-router-dom';
import { useModal } from '@/components/modal/Modal';
import { BackButton } from '@/components/layout/NavBar';

export interface SimpleMachine {
  id: string
  imei: string

  manufacturer: string
  model: string
  serialNumber: string
  internalNumber: string
  machineTypeId: string
  name: string
}

export const MyMachinesPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const searchTableRef = useRef<SearchTableRef>(null)
  const navigate = useNavigate()
  const { openModal } = useModal()

  useResponsiveChange()

  const tableParams: SearchTableParams<SimpleMachine> = {
    fetch: (q: PageQuery): Promise<PageResponse<SimpleMachine>> => {
      return services.session.fetchWithToken(`/api/communal/my/machines/search?pageNumber=${q.pageNumber || ''}&pageSize=${q.pageSize || ''}&search=${q.search || ''}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        }
        return Promise.reject()
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 30,
      search: ""
    },
    // toolbox: () => <></>,
    header: () => <>
      <div className='hcol'>{session.translates.for('elements.table.machines.manufacturer')}</div>
      <div className='hcol'>{session.translates.for('elements.table.machines.model')}</div>
      <div className='hcol'>{session.translates.for('elements.table.machines.number')}</div>
      {/* <div className='hcol'>{session.translates.for('elements.table.machines.name')}</div> */}
      <div className='hcol'></div>
    </>,
    row: (row) => {
      const openDetails = () => navigate(`/communal/machine/${row.id}`)
      return <>
        <div className='col'>{row.manufacturer || '-'}</div>
        <div className='col'>{row.model || '-'}</div>
        <div className='col'>{row.internalNumber ? row.internalNumber : row.serialNumber || row.id}</div>
        {/* <div className='col'>{row.name || '-'}</div> */}
        <div className='col icocol' onClick={openDetails}>
          <i className='svgfont-link' />
        </div>
      </>
    },
    translates: session.translates
  }

  return <LoggedInPageLayout pageName='my-machines' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <SearchTable ref={searchTableRef} {...tableParams} />
  </LoggedInPageLayout>
}
